import axios from 'axios'

export default {
  getFolders: (placeId, name) => axios.get(`/api/v2/media-folder/${placeId}`),
  createFolder: (placeId, data) => axios.post(`/api/v2/media-folder/${placeId}`, data),
  updateFolder: (id, data) => axios.put(`/api/v2/media-folder/${id}`, data),
  deleteFolder: (id) => axios.delete(`/api/v2/media-folder/${id}`)
}
